import styled from 'styled-components'

export const ContactDiv = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: auto;
`

export const ContactInfoWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: auto;
	gap: 20px;
`
